export default "__VITE_ASSET__BQGfbVmh__"